
import {
  computed,
  ComputedRef,
  defineComponent,
  onMounted,
  watch
} from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { User } from "../../../domain/entities/entities";
import { dispatchError } from "../utils/error_handling";
import { Configuration } from "../../../domain/entities/configuration";

export default defineComponent({
  name: "Maintenance",
  setup() {
    const store = useStore();
    const router = useRouter();

    const user: ComputedRef<User> = computed(() => {
      return store.getters["userProfile_module/user"];
    });

    const config: ComputedRef<Configuration> = computed(() => {
      return store.getters["configuration_module/configuration"];
    });

    onMounted(async () => {
      try {
        await store.dispatch("configuration_module/get");

        if (!config.value?.isMaintenanceMode) {
          await router.push({ name: "dashboard" });
        }
      } catch (e) {
        await dispatchError(e);
      }
    });

    watch(
      () => config.value?.isMaintenanceMode,
      async (isMaintenanceMode) => {
        if (isMaintenanceMode === false) {
          await router.push({ name: "dashboard" });
        }
      }
    );

    return {
      user
    };
  }
});
